
import { RangerSourceMapMetadataBase } from './ranger-source-map.metadata.base';


export class RangerSourceMapMetadata extends RangerSourceMapMetadataBase {
  constructor() {
    super();
  }
}

export const RANGER_SOURCE_MAP_METADATA: RangerSourceMapMetadata = new RangerSourceMapMetadata();


